import React from 'react';
import { Box, Container, Typography, Grid, Stack, IconButton, Divider, Button, styled } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';

const StyledFooterLink = styled(RouterLink)(({ theme }) => ({
  textDecoration: 'none',
  color: 'rgba(255,255,255,0.7)',
  display: 'block',
  marginBottom: '8px',
  transition: 'color 0.2s ease',
  '&:hover': {
    color: 'white'
  }
}));

const FooterLink = ({ to, children }) => (
  <StyledFooterLink to={to}>
    {children}
  </StyledFooterLink>
);

const Footer = () => {
  return (
    <Box component="footer" sx={{ bgcolor: '#1a2027', color: 'white', pt: 6, pb: 3 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={5}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Box 
                sx={{ 
                  display: 'flex', 
                  alignItems: 'center',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%',
                  p: 0.8,
                  mr: 1
                }}
              >
                <FlightTakeoffIcon sx={{ fontSize: 28 }} />
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography 
                  component="div"
                  sx={{
                      fontFamily: 'Poppins, sans-serif',
                      fontWeight: 700,
                      letterSpacing: '.1rem',
                      backgroundImage: 'linear-gradient(45deg, #fff, #f0f0f0)',
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text',
                      color: 'transparent',
                      WebkitTextFillColor: 'white' ,
                      textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                      textDecoration: 'none',
                      fontSize: { xs: '1.2rem', md: '1.5rem' },
                      mb: -0.3,
                      lineHeight: 1,
                  }}
                > 
                  roamzap
                </Typography>
                <Typography
                  variant="caption"
                  noWrap
                  sx={{
                    fontFamily: 'Poppins, sans-serif',
                    letterSpacing: '.02rem',
                    fontWeight: 700,
                    color: 'white',
                    textDecoration: "none",
                    fontSize: { xs: '0.55rem', md: '0.65rem' },
                    mt: 0.2,
                    opacity: 0.9,
                  }}
                >
                  Travel Plans In a Zap !
                </Typography>
              </Box>
            </Box>
            <Typography variant="body2" sx={{ mb: 2, color: 'rgba(255,255,255,0.7)' }}>
              Your intelligent vacation planner that helps you create memorable travel experiences.
              Let AI handle the planning details while you focus on your dream vacation.
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3.5}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Quick Links
            </Typography>
            <Stack spacing={1}>
              <FooterLink to="/about">About Us</FooterLink>
              <FooterLink to="/contact">Contact</FooterLink>
              <FooterLink to="/travel-tips">Travel Tips</FooterLink>
              <FooterLink to="/faqs">FAQs</FooterLink>
            </Stack>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3.5}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Legal
            </Typography>
            <Stack spacing={1}>
              <FooterLink to="/privacy">Privacy Policy</FooterLink>
              <FooterLink to="/terms">Terms of Service</FooterLink>
              <FooterLink to="/cookies">Cookie Policy</FooterLink>
            </Stack>
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.1)' }} />
        
        <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="body2" color="rgba(255,255,255,0.7)">
            © {new Date().getFullYear()} roamzap. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 